<template>
  <div>
    <div class="hero" :style="{ backgroundImage: 'url(' + require(`@/assets/` +  item) + ')' }">
      <div class="container bg-line"></div>
      <div class="container">
        <app-match :item="match" class="match-schedule white"></app-match>
        <div class="timeline">
          <div class="bg-count">
            <div v-for="(i, index) in arr" :key="index">
              <span>{{i}}</span>
            </div>
          </div>
          <div>
            <div
              class="moment"
              :class="item.length >  1 ? 'column' : ''"
              v-for="(item, index) in arrTime"
              :key="index"
              :style="{ left: item[0].time + '%'}"
            >
              <div v-if="item.length ==  1">
                <div
                  class="content"
                  v-for="(i,index) in item"
                  :key="index"
                  :class="i.action.name == 'Goal!' ? 'goal' : ''"
                >
                  <div class="info">
                    <span class="score">{{i.score}}</span>
                    <span>{{i.playerName}}</span>
                  </div>
                  <span class="circle"></span>
                  <span class="icon">
                    <img v-if="i.action != null" :src="i.action.iconUrl" />
                  </span>
                </div>
              </div>
              <div v-else>
                <div class="content">
                  <div class="info" v-for="(i,index) in item" :key="index">
                    <span class="img">
                      <img v-if="i.action != null" :src="i.action.iconUrl" />
                    </span>
                    <span>
                      {{i.playerName}}
                      <span>({{i.score}})</span>
                    </span>
                  </div>
                  <span class="circle"></span>
                  <span class="icon">...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <h4 class="title">MATCH TIMELINE</h4>
      <div class="Expander-overlay">
        <div class="Expander-time-part">
          <app-match-time
            v-if="timelineArrFT.length !=0"
            :matchTime="timelineArrFT"
            title="FULL TIME"
            class="game-finish"
          >
            <img :src="match.firstTeam.logoUrl" />
            <p>
              {{match.firstTeamScore}}
              <span>:</span>
              {{match.secondTeamScore}}
            </p>
            <img :src="match.secondTeam.logoUrl" />
          </app-match-time>
          <app-match-time
            v-if="timelineArrHT.length !=0"
            :matchTime="timelineArrHT"
            title="HALF TIME"
          >
            <img :src="match.firstTeam.logoUrl" />
            <p>
              {{halfTimeScore.firstTeam}}
              <span>:</span>
              {{halfTimeScore.secondTeam}}
            </p>
            <img :src="match.secondTeam.logoUrl" />
          </app-match-time>
          <app-match-time
            v-if="timelineArrGS.length !=0"
            :matchTime="timelineArrGS"
            title="GAME STARTED!"
          >
            <img :src="match.firstTeam.logoUrl" />
            <p>
              0
              <span>:</span>
              0
            </p>
            <img :src="match.secondTeam.logoUrl" />
          </app-match-time>
          <p
            v-if="timelineArrHT.length == 0 && timelineArrFT.length == 0 && timelineArrGS.length == 0"
          >NO INFORMATION</p>
        </div>
      </div>
    </div>
    <BottomSection></BottomSection>
  </div>
</template>
<script>
import Match_card from "@/components/shared/Match_card";
import Match_time from "../components/shared/Timeline_block";
const url = process.env.VUE_APP_URL;
const BottomSection = () => import("@/components/shared/BottomSection");

export default {
  name: "match-result",
  data() {
    return {
      arr: ["0", "15", "30", "45", "60", "75", "90"],
      arrTime: [],
      id: this.$route.params.id,
      info: {},
      timelineArrGS: [],
      timelineArrHT: [],
      timelineArrFT: [],

      bridgeportAction: [],
      otherTeamAction: [],
      item: "img/schedule.jpg",
    };
  },
  watch: {
    $route(to, from) {
      this.id = to.params.id;
      this.matchInfo();
    },
  },
  computed: {
    match() {
      const matchId = this.$route.params.id;
      var infoThis;
      this.$store.getters.match.filter((el) => {
        if (el.id == matchId) {
          infoThis = el;

          var today = new Date();
          today.setHours(today.getHours() - 2);
          if (Date.parse(el.eventDate) < Date.parse(today)) {
            el.time = "past";
          } else if (Date.parse(el.eventDate) > Date.parse(today)) {
            el.time = "future";
          }
          return infoThis;
        }
      });
      return infoThis;
    },
    halfTimeScore() {
      var obj = {
        firstTeam: "",
        secondTeam: "",
      };
      this.timelineArrGS.map((el, index) => {
        if (index == 0) {
          obj.firstTeam = el.score.split(":")[0];
          obj.secondTeam = el.score.split(":")[1];
          return obj;
        }
      });
      return obj;
    },
  },
  methods: {
    setMatch() {
      this.axios
        .get(url + "/matches", {
          headers: {
            "Access-Control-Allow-Origin": "*",
            accept: "application/json",
          },
        })
        .then((response) => {
          const payload = response.data;
          this.$store.dispatch("setMatch", payload);
          this.matchInfo();
        });
    },
    sortMinute(arr) {
      return arr.sort((a, b) => (a.minute > b.minute ? 1 : -1));
    },
    matchInfo() {
      const matchId = this.$route.params.id;
      this.$store.getters.match.filter((el) => {
        if (el.id == matchId) {
          //заполняем инфо для всего матча
          //заполняем массивы для timelines
          this.sortMinute(el.timelines);
          this.info = el;
        }
      });
      this.info.timelines.map((element) => {
        if (element.minute <= 90) {
          var elementTime = {},
            masNew = [];
          elementTime.time = element.minute;
          elementTime.action = element.timelineAction;
          elementTime.playerName = element.playerName;
          elementTime.score = element.score;
          elementTime.isEnemyPlayer = element.isEnemyPlayer;

          this.arrTime.push(elementTime);
          //this.arrTime.push(masNew);
        }
        if (element.minute < 45) {
          this.timelineArrGS.push(element);
        } else if (element.minute > 45 && element.minute < 90) {
          this.timelineArrHT.push(element);
        } else {
          this.timelineArrFT.push(element);
        }
      });

      let oldTime = null,
        newMass = [];
      let res = this.arrTime.map((obj, index) => {
        newMass.push([obj]);
        if (oldTime === obj.time) {
          newMass[index - 1].splice(index, 0, obj);
          newMass.splice(index, 1);
        }
        oldTime = obj.time;
      });
      this.arrTime = newMass;

      this.info.timelines.map((element) => {
        if (
          element.timelineAction.name == "Goal!" &&
          element.isEnemyPlayer == true
        ) {
          this.otherTeamAction.push(element);
        } else if (
          element.timelineAction.name == "Goal!" &&
          element.isEnemyPlayer != true
        ) {
          this.bridgeportAction.push(element);
        }
      });
    },
    /*momentsReverse() {
      this.info.moments = this.info.moments.reverse();
    }*/
  },
  mounted() {
    this.setMatch();
    //this.momentsReverse(); //если данные приходят с начала матча
  },
  updated() {
    //this.setMatch();
    //this.matchInfo();
  },
  components: {
    "app-match": Match_card,
    "app-match-time": Match_time,
    BottomSection,
  },
};
</script>
<style lang="scss" scoped>
.hero {
  position: relative;
  min-height: calc(100vh - 8rem);
  height: auto;
  max-height: 80rem;
  background-size: cover;
  background-position: top center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 3rem 0;
  &:after {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    content: "";
    background: linear-gradient(
      271.22deg,
      #0a0736 0.31%,
      rgba(30, 27, 68, 0.864583) 40.1%,
      rgba(32, 29, 74, 0.69708) 81.44%,
      rgba(33, 30, 81, 0.507924) 99.52%,
      rgba(38, 34, 98, 0.15) 99.53%
    );
    z-index: 1;
  }
  @media only screen and (max-width: 992px) {
    max-height: 60rem;
  }
  @media only screen and (max-width: 599px) {
    min-height: 0;
  }
  .container {
    height: 100%;
    position: relative;
    z-index: 2;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    &.bg-line {
      display: block;
      position: absolute;
    }
  }
  & + .container {
    padding: 8rem 0 9.5rem;
    @media only screen and (max-width: 768px) {
      padding: 4rem 0;
    }
  }
}
h4.title {
  margin-bottom: 5.5rem;
  @media only screen and (max-width: 599px) {
    margin-bottom: 3.5rem;
  }
}
.match-schedule {
  display: flex;
  flex-direction: column;
  .table {
    margin-bottom: 2rem;
    .img {
      height: 10rem;
    }
  }
}
.Expander-overlay {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: reverse;
  -ms-flex-direction: column-reverse;
  flex-direction: column-reverse;
}

.timeline {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  //position: absolute;
  //bottom: 11rem;
  padding-top: 10rem;
  padding-bottom: 5rem;
  @media only screen and (max-width: 992px) {
    padding: 7rem 0 5rem;
  }
  @media only screen and (max-width: 768px) {
    display: none;
  }
  width: 100%;
  .bg-count {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: space-between;
    color: #fff;
    height: 2px;
    background-color: #fbbb00;
    &:after,
    &:before {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      content: "";
      width: 1px;
      height: 16px;
      background-color: #fbbb00;
      z-index: 2;
    }
    &:before {
      left: 1px;
    }
    &:after {
      right: 0;
    }
    div {
      position: relative;
      height: 2px;
      width: 1px;
      margin-top: -7px;
      &:after {
        position: absolute;
        top: 0;
        left: 0;
        content: "";
        width: 1px;
        height: 16px;
        background: #ce9a00;
      }
    }
    span {
      position: absolute;
      bottom: 8px;
      left: 50%;
      transform: translateX(-50%);
      font-size: 12px;
      line-height: 1;
      color: #fbbb00;
    }
    & + div {
      position: absolute;
      width: 111%;
    }
  }
  .moment {
    position: absolute;
    bottom: -51px;
    transform: translate(-50%, 0);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    z-index: 2;
    width: 12px;
    .content {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;
      .info {
        display: flex;
        flex-direction: column;
        align-items: center;
        opacity: 0;
        transition: all 0.3s ease-in-out;
        span {
          color: #fff;
          font-size: 11px;
          font-weight: 500;
          line-height: 1.45;
          white-space: nowrap;
          span {
            letter-spacing: 3px;
          }
        }
        .score {
          line-height: 21px;
          font-weight: 700;
          text-align: center;
          color: #fff;
          letter-spacing: 3px;
          font-size: 0;
          margin-bottom: 4px;
        }
      }
      &.goal {
        .info {
          .score {
            font-size: 1.8rem;
            @media only screen and (max-width: 992px) {
              font-size: 14px;
            }
          }
        }
      }
      .icon {
        display: inline-block;
        height: 20px;
      }
    }
    &.column {
      & > div {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
      }
      .content {
        .icon {
          color: #fff;
          font-size: 3rem;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          line-height: 0;
        }
        .info {
          flex-direction: row;
          width: 100%;
          margin-bottom: 5px;
          span.img {
            display: flex;
            justify-content: center;
            margin-right: 7px;
          }
          img {
            max-width: 12px;
          }
        }
      }
    }
    img {
      @media only screen and (max-width: 992px) {
        width: 15px;
      }
    }
    &.goal {
      img {
        -webkit-filter: contrast(200%) invert(1);
        filter: contrast(200%) invert(1);
      }
      .scoreVisible {
        font-size: 1.8rem;
        @media only screen and (max-width: 992px) {
          font-size: 14px;
        }
      }
    }
    .circle {
      position: relative;
      width: 12px;
      height: 12px;
      background-color: #fff;
      border-radius: 50%;
      margin: 25px 0;
    }
    .circle {
      &:after {
        position: absolute;
        content: "";
        width: 3.2rem;
        height: 3.2rem;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) scale(0);
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.2);
        transition: all 0.3s ease-in-out;
      }
    }

    &:hover {
      .content .info {
        opacity: 1;
      }
      .circle:after {
        transform: translate(-50%, -50%) scale(1);
      }
    }
    & > div {
      display: flex;
      align-items: center;
      //width: 12px;
    }
  }
}

@keyframes up {
  0% {
    opacity: 0;
    transform: translate(0, 20px);
  }
  100% {
    opacity: 1;
    transform: translate(0, 0);
  }
}
</style>